<template>
  <Link
    :href="localeRoute('frontend.news.show', [news.categories[0].slug, news.slug])"
    class="border-2 border-black p-4 rounded-lg latest-news-items lg:relative lg:z-20 lg:bg-white"
  >
    <img
      v-if="news.coverImage"
      :src="news.coverImage.url"
      class="rounded-lg w-full"
      loading="lazy"
    >

    <span class="block mt-4 text-sm font-bold">
      {{ __('components.news.title') }}
    </span>

    <div class="latest-news-items-heading text-2xl no-underline hover:underline block mt-3 font-bold text-black lg:text-4xl truncate">
      {{ news.title }}
    </div>

    <div class="block text-sm mt-1 mb-0 overflow-y-hidden">
      <p class="line-clamp-3">
        {{ news.excerpt }}
      </p>
    </div>

    <div class="border-t-gray-300 border-t flex flex-wrap items-center justify-between mt-3 pt-4">
      <div class="flex flex-wrap space-x-2">
        <div
          v-for="category in news.categories"
          :key="`category-${category.slug}`"
          class="text-xs text-gray-300 border-gray-300 border py-2 px-4 rounded"
        >
          {{ category.name }}
        </div>
      </div>

      <span class="text-sm font-bold text-gray-300">
        {{ news.createdAt }}
      </span>
    </div>
  </Link>
</template>

<script>
export default {
  props: {
    news: {
      required: true,
      type: Object,
    },
  },
};
</script>
